import { ButtonComp } from 'atoms/Buttons';
import React, { useContext } from 'react';
import {
  getTernaryValue,
  getFullImagePath,
  getEmptyObjectforNull,
  computePriceBaseOnTax,
  getUserType,
} from 'common/utilities/utils';
import Accordian from 'atoms/Accordian/Accordian';
import ImageComponent from 'atoms/Image';
import { CART_PAGE_CONSTANTS } from '../../Constants/CartPageConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { useDispatch, useSelector } from 'react-redux';
import { UserOrderContext } from 'context/context';
import FoodItemListHandlers from './FoodItemListHandlers';
import CartAlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import CartAlertFormInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import { useHistory } from 'react-router-dom';
import { QuantityModifier } from 'molecules/QuantityModifier';
import CartNotification from './CartNotification';
import OffersCoupon from './OffersCoupon';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const FoodItemList = props => {
  const {
    contentData = [],
    cartSummary,
    addHope,
    carryBag,
    maxItemCountPerLineItem,
    isMobile,
    currencySymbol,
    isModalOpen,
    bucketId,
    showPriceWithTax,
  } = props;
  const { Error, Ellipse } = IMAGE_PATH;
  const { CART_FOOD_LIST_ITEM, QUANTITY_ACTION, ALERT, ITEM_LIST_NAME } = CART_PAGE_CONSTANTS;
  const { EDIT, REMOVE, REMOVE_ALL, ITEM_QUANTITY, MODIFIER_QUANTITY, ADD_MORE_MENU } = CART_FOOD_LIST_ITEM;
  const { flatResponse: { productMapById = {} } = {} } = getEmptyObjectforNull(
    useSelector(({ menuReducer }) => menuReducer),
  );
  const tenantReducer = useSelector(data => data.tenantReducer || {});
  const { tenantId } = tenantReducer;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { cartAlertData, cartItems } = userOrderState;
  const dispatch = useDispatch();
  const history = useHistory();
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const userType = getUserType(userParams?.localized, userParams?.loggedIn);
  const {
    itemAllRemoveAction,
    itemQuantityHandler,
    itemRemoveHandler,
    itemEditHandler,
    itemAllRemoveHandler,
    addMoreMenuHandler,
    showCartAlert,
  } = FoodItemListHandlers(
    { ...cartSummary, foodLines: contentData, itemListName: ITEM_LIST_NAME },
    tenantId,
    cartItems,
    productMapById,
    userOrderStateDispatch,
    dispatch,
    history,
    userType,
  );

  const accordionFoodItem = item => {
    return (
      <Accordian
        header={item.foodName}
        //subHeader={item.modifiers.length > ACCORDION_MODIFIER_MAX_QUANTITY ? null : null}
      >
        <div className='cart-food-modifier'>
          <ul>
            {item?.modifiers?.length
              ? item.modifiers.map(mod => {
                  return <li>{mod}</li>;
                })
              : null}
          </ul>
        </div>
      </Accordian>
    );
  };
  const alternateAccordionFoodItem = item => {
    return (
      <React.Fragment>
        <div className='cart-food-name'>{item.foodName}</div>
        <div className='cart-food-modifier'>
          <ul>
            {item?.modifiers?.length
              ? item.modifiers.map(mod => {
                  return <li>{mod}</li>;
                })
              : null}
          </ul>
        </div>
      </React.Fragment>
    );
  };

  const getImageClass = flag => {
    if (flag) {
      return 'unavailable-image cart-food-image';
    } else {
      return 'cart-food-image';
    }
  };

  const getCartFoodClassName = flag => {
    if (flag) {
      return 'outofstock cart-highlight cart-food-item-container';
    } else {
      return 'cart-food-item-container';
    }
  };
  const getQuantityPrice = (item, isAddedFromCoupon) => (
    <div
      className={`cart-food-quantity-price ${getTernaryValue(
        item.modifiers?.length === 0,
        'empty-mods-quantity-price',
        '',
      )} 
      ${isAddedFromCoupon && 'coupon-item-quantity-price'}`}
    >
      {getTernaryValue(
        !isAddedFromCoupon && !item.toRemove,
        <QuantityModifier
          itemCount={item.quantity}
          itemQuantity={ITEM_QUANTITY}
          updateItemQuantity={itemQuantityHandler}
          quantityAction={QUANTITY_ACTION}
          item={item}
          itemName={item.foodName}
          maxItemCountPerLineItem={maxItemCountPerLineItem}
          cartItemCount={1}
          hideChild={true}
          data-testid='quantity-modifier-item'
        />,
        null,
      )}
      {!item.toRemove && !item.requireModification ? (
        <div className='cart-food-price'>
          {currencySymbol}
          {computePriceBaseOnTax(item.cartPrice, item?.taxAmount, showPriceWithTax)}
        </div>
      ) : null}
      {!item.toRemove && item.requireModification ? (
        <div className='cart-food-price'>
          <span className='old-price'>
            {currencySymbol}
            {computePriceBaseOnTax(item.cartPrice, item?.taxAmount, showPriceWithTax)}
          </span>
          <span className='modified-price'>
            {currencySymbol}
            {computePriceBaseOnTax(item.menuPrice, item?.taxAmount, showPriceWithTax)}
          </span>
        </div>
      ) : null}
    </div>
  );

  return (
    <React.Fragment>
      {!isMobile ? (
        <div className='cart-notification'>
          <CartNotification contentData={contentData} isModalOpen={isModalOpen} />
        </div>
      ) : null}
      <div className='cart-food-container' data-testid='cart-food-item-test'>
        <div className='cart-discount-errors'>
          <div className='cart-food-discount-lines'>
            {userOrderState?.couponErrorMessage && (
              <div className='discount-error'>
                <img className='discount-error-icon' src={Ellipse} alt='close' />
                <span>{userOrderState?.couponErrorMessage}</span>
              </div>
            )}
          </div>
        </div>
        {isMobile && (
          <div className='cart-offers-mobile'>
            <OffersCoupon bucketId={bucketId} />
          </div>
        )}
        {contentData &&
          contentData
            .filter(({ name }) => name !== addHope && name !== carryBag)
            .map(item => {
              const { discountComponents } = item;
              const isAddedFromCoupon = discountComponents?.length > 0;
              console.log('Food List', item);
              return isMobile ? (
                <div key={item.foodItemId} className={getCartFoodClassName(item.toRemove)}>
                  <div className='cart-food-edit-container'>
                    {item.toRemove && (
                      <div data-testid='outofstock-text' className='outofstock-text'>
                        <ImageComponent srcFile={Error} className='location-alert-icon' />
                        <span>{translateWithI18Next('unavailable')}</span>
                      </div>
                    )}
                  </div>
                  <div className='image-cart-content'>
                    <ImageComponent
                      defaultPath={getFullImagePath(null, tenantReducer, true)}
                      srcFile={item.imageData.src}
                      altText=' '
                      className={getImageClass(item.toRemove)}
                    />
                    <div className='cart-food-content'>
                      {(item.modifiers.length > MODIFIER_QUANTITY && accordionFoodItem(item)) ||
                        alternateAccordionFoodItem(item)}
                      {!isAddedFromCoupon && item.customizable && (
                        <span
                          className='cart-food-edit'
                          data-testid='cart-food-edit'
                          onClick={() => itemEditHandler(item)}
                        >
                          {translateWithI18Next(EDIT)}
                        </span>
                      )}
                      {!isAddedFromCoupon && (
                        <span
                          className='cart-food-remove'
                          data-testid='cart-food-remove'
                          onClick={() => itemRemoveHandler(item, tenantReducer.currencyConversionFactor)}
                        >
                          {translateWithI18Next(REMOVE)}
                        </span>
                      )}
                    </div>
                  </div>
                  {getQuantityPrice(item, isAddedFromCoupon)}
                </div>
              ) : (
                <div key={item.foodItemId} className={getCartFoodClassName(item.toRemove)}>
                  <ImageComponent
                    defaultPath={getFullImagePath(null, tenantReducer, true)}
                    srcFile={item.imageData.src}
                    altText={item.imageData.altText}
                    className={getImageClass(item.toRemove)}
                  />
                  <div className='cart-food-content-parent'>
                    <div className='cart-food-content row'>
                      {(item.modifiers.length > MODIFIER_QUANTITY && accordionFoodItem(item)) ||
                        alternateAccordionFoodItem(item)}
                      {item.toRemove && (
                        <div data-testid='outofstock-text' className='outofstock-text'>
                          <ImageComponent srcFile={Error} className='location-alert-icon' />
                          <span className='outoftext-span'>{translateWithI18Next('unavailable')}</span>
                        </div>
                      )}
                    </div>
                    <div className='cart-action-price-quantity row'>
                      <div>
                        {getTernaryValue(
                          !isAddedFromCoupon && !item.toRemove && item.customizable,
                          <span
                            className='cart-food-edit'
                            data-testid='cart-food-edit'
                            onClick={() => itemEditHandler(item)}
                          >
                            {translateWithI18Next(EDIT)}
                          </span>,
                          null,
                        )}
                        {!isAddedFromCoupon && (
                          <span
                            tabindex='0'
                            aria-label='do you want to remove the above itams'
                            className='cart-food-remove'
                            data-testid='cart-food-remove'
                            onClick={() => itemRemoveHandler(item, tenantReducer.currencyConversionFactor)}
                          >
                            {translateWithI18Next(REMOVE)}
                          </span>
                        )}
                      </div>
                      {getQuantityPrice(item, isAddedFromCoupon)}
                    </div>
                  </div>
                </div>
              );
            })}
        <div className='cart-food-remove-container'>
          <span
            tabindex='0'
            aria-label='Remove all products'
            className='cart-food-remove-all'
            data-testid='remove-all-btn'
            onClick={itemAllRemoveHandler}
          >
            {translateWithI18Next(REMOVE_ALL)}
          </span>
          <ButtonComp
            className='button  whiteButton blackBorder add-more-menu'
            ariaLable='add more menu'
            onClickHandler={addMoreMenuHandler}
            data-testid='add-more-menu'
          >
            {translateWithI18Next(ADD_MORE_MENU)}
          </ButtonComp>
        </div>
        {cartAlertData?.showCartAlert && (
          <CartAlertFormInsideModel
            classNames=''
            handleClose={() => showCartAlert(false)}
            CartAlertForm={
              <CartAlertForm
                title={translateWithI18Next(ALERT.REMOVE_ALL_MSG)}
                confirmButtonText={translateWithI18Next(ALERT.REMOVE_ALL)}
                cancelButtonText={translateWithI18Next(ALERT.CANCEL)}
                cancelHandler={() => showCartAlert(false)}
                confirmHandler={() => itemAllRemoveAction(contentData)}
              />
            }
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default FoodItemList;
